import React, { useState } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Lists from './containers/lists';
import Search from './containers/search';
import ViewList from './components/lists/viewList';

const App = () => {
  const [selectedListId, setSelectedListId] = useState('no-list-selected');

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/view/:listId">
          <ViewList />
        </Route>
        <Route path="/">
          <Lists
            selectedList={selectedListId}
            setSelectedList={setSelectedListId}
          />
          <Search
            selectedListId={selectedListId}
            setSelectedListId={setSelectedListId}
          />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default App;
